'use client'

import Link from 'next/link'
import { usePathname } from 'next/navigation'
import { Home, CarFront, Users, BarChart3, Map, Wallet } from 'lucide-react'

const navigation = [
  { name: 'TỔNG QUAN', href: '/', icon: Home },
  { name: 'KHO ĐẤT', href: '/kho-dat', icon: Map },
  { name: 'KHO XE', href: '/xe', icon: CarFront },
  { name: 'KHÁCH HÀNG', href: '/khach-hang', icon: Users },
  { name: 'B.CÁO K.ĐẤT', href: '/bao-cao-kho-dat', icon: BarChart3 },
  { name: 'B.CÁO XE', href: '/bao-cao', icon: BarChart3 },
  { name: 'QL VỐN', href: '/quan-ly-von', icon: Wallet },
]

export default function Sidebar() {
  const pathname = usePathname()

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="hidden md:flex h-full w-64 flex-col border-r border-slate-100 bg-white shrink-0 z-20">
        <div className="flex h-16 shrink-0 items-center border-b border-slate-100 px-6">
          <h1 className="text-[1.3rem] font-black tracking-tighter text-emerald-800 uppercase flex flex-col leading-tight">
            Lê Hải <span className="text-emerald-500 text-[0.8rem] font-bold tracking-[0.15em]">Mua Bán XE</span>
          </h1>
        </div>
        <div className="flex-1 overflow-y-auto py-6">
          <nav className="space-y-1 px-4">
            {navigation.map((item) => {
              const isActive = pathname === item.href || (item.href !== '/' && pathname.startsWith(item.href + '/'))
              return (
                <Link
                  key={item.name}
                  href={item.href}
                  className={`group flex items-center gap-3 rounded-full px-4 py-3.5 text-sm font-semibold transition-all duration-200 ${
                    isActive
                      ? 'bg-emerald-50 text-emerald-700 shadow-sm ring-1 ring-emerald-500/10'
                      : 'text-slate-500 hover:bg-slate-50 hover:text-slate-900'
                  }`}
                >
                  <item.icon className={`h-5 w-5 transition-colors ${isActive ? 'text-emerald-600' : 'text-slate-400 group-hover:text-slate-500'}`} />
                  {item.name}
                </Link>
              )
            })}
          </nav>
        </div>
      </div>

      {/* Mobile Bottom Navigation */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-lg border-t border-slate-200 pb-[env(safe-area-inset-bottom,8px)] pt-1 shadow-[0_-10px_20px_-10px_rgba(0,0,0,0.05)]">
        <nav className="flex justify-between items-center px-1">
          {navigation.map((item) => {
            const isActive = pathname === item.href || (item.href !== '/' && pathname.startsWith(item.href + '/'))
            return (
              <Link
                key={item.name}
                href={item.href}
                className={`flex flex-col items-center flex-1 gap-1 py-1.5 transition-colors`}
              >
                <div className={`p-1 rounded-xl transition-all ${isActive ? 'bg-emerald-100 text-emerald-700 font-extrabold scale-110' : 'text-slate-400'}`}>
                  <item.icon className="h-5 w-5" strokeWidth={isActive ? 2.5 : 2} />
                </div>
                <span className={`text-[9px] text-center w-full truncate px-0.5 ${isActive ? 'text-emerald-800 font-extrabold' : 'text-slate-500 font-medium'}`}>
                  {item.name}
                </span>
              </Link>
            )
          })}
        </nav>
      </div>
    </>
  )
}
